function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M13.23 18.04h-3.3l-.86-2.3H9l.95-5.67 6.4-2.2 3.76 3.6v.1l-1.2 3.6-2.9-.48-2.3 1.44-.45 1.88zM6.1 15.8l-1.03-.98L3.2 8.2l5.48 1.87-.95 5.68H6.17l-.06.04zm14-6.05V7.7l-3.7-3.76.73 2.96 2.98 2.85zM14.9 3.2L7.73 5l-3.7 2.15 5.3 1.82 6.47-2.24-.9-3.52zM6.5 17l-1.5.85v1.7L6 20h2l1-.85L8.2 17H6.5zm9.77-1l-1.5.95-.77 3.23 1.75.82h3.5L21 20l-1.75-3.5-2.98-.5z",
  fill: "currentColor",
  fillRule: "evenodd"
});

var SvgLocationStone = function SvgLocationStone(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24
  }, props), _ref);
};

export default SvgLocationStone;